import { QuestionCircleOutlined, BellOutlined } from '@ant-design/icons';
import { SelectLang as UmiSelectLang } from '@umijs/max';
import React, { useEffect, useState } from 'react';
import { requestNotificationPermission, onMessageListener } from '../../firebase';
import {
  registerFCMToken,
  fetchNotifications,
  markAsRead,
} from '../../services/ant-design-pro/notification';
import { Badge, Dropdown, List } from 'antd';

import { useModel } from '@umijs/max';

export type SiderTheme = 'light' | 'dark';

export const SelectLang = () => {
  return (
    <UmiSelectLang
      style={{
        padding: 4,
      }}
    />
  );
};

export const Notification = () => {
  const { initialState } = useModel('@@initialState');
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    // Request notification permission and register FCM token
    requestNotificationPermission().then((token: string) => {
      if (token) {
        // Send this token to your backend
        registerFCMToken(token)
          .then(() => console.log('FCM Token registered'))
          .catch((err) => console.error('Failed to register FCM Token:', err));
      }
    });

    // Listen for incoming messages
    onMessageListener()
      .then((payload) => {
        if (payload) {
          console.log('Message received in foreground:', payload);
          // Optionally update notifications here
        }
      })
      .catch((err) => console.error('Failed to receive message:', err));

    // Fetch notifications
    fetchNotifications();
  }, []);

  const notificationMenu = (
    <List
      dataSource={notifications}
      renderItem={(item: any) => (
        <List.Item
          onClick={() => markAsRead(item.id)}
          style={{ cursor: 'pointer', backgroundColor: item.is_read ? '#fff' : '#f0f0f0' }}
        >
          {item.message}
        </List.Item>
      )}
      style={{
        backgroundImage:
          initialState?.settings?.navTheme === 'realDark'
            ? 'background-image: linear-gradient(75deg, #1A1B1F 0%, #191C1F 100%)'
            : 'background-image: linear-gradient(75deg, #FBFDFF 0%, #F5F7FF 100%)',
      }}
    />
  );
  return (
    <Dropdown overlay={notificationMenu} trigger={['click']}>
      <Badge count={unreadCount}>
        <BellOutlined style={{ fontSize: '20px', cursor: 'pointer' }} />
      </Badge>
    </Dropdown>
  );
};
